export const createCSS = (text, title) => {
  const BLOB = new Blob([text], { type: "text/css" });
  const U = URL.createObjectURL(BLOB);
  const LINK = document.createElement("a");
  LINK.download = title.concat(".css");
  LINK.href = U;
  LINK.click();
};
